import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { BasicFlex } from "../../utils/Common";

import { useNavigate } from 'react-router-dom';

import { formatTime, displayTruncated, formatGenericDate, formatGenericTime, getHebrewDate, getCandleLighting, getHavdala, getHolidayEvents, getEvents, getParsha, checkBookingAvailabilityByTime } from '../../utils/util';

import { getEventHeight, getEventTopPos, parseTime } from './helpers';

import CalendarEditCur from '../../images/calendar2.png';

import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';

import WigIconWrapper from '../../images/WigIconWrapper';

import AppointmentMenu from '../Appointments/Components/Menu';

import AppointmentComments from '../Appointments/Components/AppointmentComments';

import useIsMobile from '../../hooks/useIsMobile';

import { useTheme, darken, IconButton, Avatar, Tooltip, lighten, Divider } from '@mui/material';

import { useCalendarContext } from '../../contexts/Calendar';

import { useNewEvent } from '../../contexts/NewEvent';

const BasicRibbon = styled.div`
  background-color: ${props => props.theme.colors.ribbon};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin-top: 2rem;
`

const HebrewMuted = styled.div`
  font-size: 1.2rem;
  font-weight: 400;
  font-family: "Bona Nova";
  color: ${props => props.theme.colors.mildText};
`

const HebrewTime = styled(HebrewMuted)`
 font-family: "Montserrat";
`

const TimeDot = styled.div`
  height: .7rem;
  width: .7rem;
  border-radius: 50%;
  background-color: ${props => props.$dotColor || props.theme.colors.primary};
`

const Time = styled.div`
  display: flex;
  align-items: center;
  gap: .3rem;
`
const HebTime = styled(Time)`
  display: flex;
  align-items: center;
  gap: .3rem;
`

const HebEventTitle = styled(HebrewMuted)`
  flex-grow: 1;
  text-align: right;
`

const MonthEvent = styled(BasicFlex)`
  margin: 0 .2rem;
  margin-bottom: 1px;
  padding: .2rem .3rem;
  opacity: .7;
  background-color: ${props => props.$bg || props.theme.colors.primaryFaint};
  border-left: 5px solid ${props => props.$border || props.theme.colors.primary};
  width: calc(100% - .4rem);
  border-radius: 2px;
  cursor: pointer;
`;

const FullDateEvent = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  border-radius: 5px;
  padding: .5rem .5rem;
  gap: .5rem;
  box-shadow: 0 3px 5px 0 rgba(0,0,0,.16);
  font-family: "Bona Nova";
  margin: 0;
  height: fit-content;
 
  &.roshchodesh {
    background-color:#a99ac7;
    border: 1px solid #a99ac7;
    color:#FFF;
  }

  &.parashat {
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.dark};
    font-weight: 700;
  }

  &.havdalah, &.candles {
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.dark};

    .time {
      display: flex;
      align-items: center;
      border-radius: 3px;
      /* border: 2px solid ${props => props.theme.colors.border}; */
      box-shadow: 0 3px 5px 1px rgba(0,0,0,.12);
      padding: .1rem .6rem;
      gap: .6rem;

      svg {
        position: relative;
        top: .3rem;
      }
    }
  }

  &.major-holiday {
    background-color: #f8c296;
    border: 1px solid #febd88;
    color:#FFF;
    font-weight: 500;
    font-size: 1.6rem;
  }
`;

const Customer = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  color: ${props => props.theme.colors.text};
`

const StartTime = styled.div`
  font-size: 1.2rem;
`


/*************  Timeline Common Styles  ************** */


const TimelineTableHead = styled.div`
 width: 100%;
`;

const TimelineTableWeekBar = styled.div`
  display: flex;
`

const TimelineTableDateEventBar = styled.div`
  display: flex;
  flex-basis: 0;
  flex-grow: 1;
  background-color: ${props => props.theme.colors.white};
`;

const TimelineSpacer = styled.div`
  min-width: 8.5rem;

  @media ${props => props.theme.breaks.down('md')} {
   min-width: 4.5rem; 
  }
`;

const TimelineFullDateEventsContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  background-color: ${props => props.theme.colors.body};
  /* padding: 1rem 0; */
  padding-left: ${props => props.$noPad ? ".2rem" : "8.5rem"};
  padding-right: ${props => props.$noPad ? ".2rem" : "3rem"};
  justify-content: space-between;
  color: ${props => props.theme.colors.lightText};
  max-height: 4rem;
  overflow-y: auto;
`;

const TimelineLegalHolidays = styled.div`
  display: flex;
`;

const TimelineJewishHolidays = styled.div`
  display: flex;
  flex-direction: ${props => props.$reverse ? "row-reverse" : "row"};
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: .5rem;
  padding: .5rem 0;
`;

const TimelineHeaderDay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  width: ${props => props.$auto ? "auto" : "16rem"};
  cursor: pointer;

  .day {
    font-size: 1.2rem;
    font-weight: 500;
    letter-spacing: .4px;
  } 
  .date {
    font-size: 1.8rem;
    font-weight: 400;
  }
  .hebDate {
    /* margin-top: .1rem; */
    font-size: 1.3rem;
    font-weight: 400;
    font-family: "Bona Nova";
  }

  @media ${props => props.theme.breaks.down('md')} {

    width: ${props => props.$auto ? "auto" : "8rem"};
    min-width: calc(100% / 7);
    border-left: 1px solid ${props => darken(props.theme.colors.border, .1)};
    padding: .5rem 0;

    .day {
      font-size: .9rem;
    } 
    .date {
      font-size: 1.8rem;
    }
    .hebDate {
      margin-top: 0;
      font-size: 1rem;
    }

  }
`;

const CheckedWigIcon = styled.div`
  width: 1.8rem;
  height: 1.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* border-radius: 50%; */
  border-radius: 3px;
  background-color: ${props => lighten(props.theme.colors.success, .88)};
`

const TimelineIconContainer = styled.div`
  width: 8.5rem;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${props => props.theme.breaks.down('md')} {
    width: 4.5rem;
    min-width: 4.5rem;
  }
`;

const TimelineTableBodyContainer = styled.div`
  /* max-height: 90rem; */
  height: calc(100vh - ${props => `${props?.$top + 20}px` || "31rem"}); //31rem
  /* background-color: lightblue; */
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const TimelineTrackHeader = styled.div`
  background-color: ${props => props.theme.colors.white};
  width: 100%;
  cursor: w-resize;
  display: flex;
`;

const TimelineTrackHeaderScroll = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const TimelineTrackTitle = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  padding: 2rem 1rem;
  border-left: 1px solid ${props => props.theme.colors.border};
  /* border-right: 1px solid ${props => props.theme.colors.border}; */
  flex-grow: 1;
  flex-basis: 0;
  min-width: 20rem; // 42rem old
  overflow: hidden;

  @media ${props => props.theme.breaks.down('md')} {
    min-width: calc(100% / 7); // 32rem old
    font-size: 1.2rem;
    padding: 1rem .5rem;
    text-overflow: ellipsis;
  }
`;

const TimelineTableBody = styled.div`
  height: fit-content;
  display: flex;
  background-color: white;
`;

const TableTimelineDisplay = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.$columns || 1}, 1fr);
  flex-grow: 1;
  border-top: 1px solid ${props => props.theme.colors.border};
  /* background-color: lightblue; */
  position: relative;
  overflow-x: scroll;
  // scroll horizontal
  overflow-y: hidden;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${props => props.theme.breaks.down('md')} {
    grid-template-columns: repeat(${props => props.$columns || 1}, minmax(calc(100% / 7), 1fr));
    overflow-x: hidden;
  }
`;

const TimelineEventBoard = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: azure; */
  /* opacity: .3; */
  cursor: url(${CalendarEditCur}) 16 16 , grab;
  overflow-y: hidden;

  /* added for pass through */
  pointer-events: none;
`;

const TimelineTrack = styled.div`
  position: relative;
  height: 100%;
  min-width: 20rem;

  @media ${props => props.theme.breaks.down('md')} {
    /* min-width: calc(100% / 7); */
    min-width: auto;
  }
`;

const WeekDayTrack = styled(TimelineTrack)`
  min-width: auto;
`;

const TimelineEventCardStyles = styled.div`
  position: absolute;
  top: ${props => `${props.$top}px` || '0'}; // top is set by the event start time
  left: ${props => `${props.$left}px` || '0'}; // left is set by the column
  height: ${props => `${props.$height}px` || '6rem'}; // height is set by the event duration
  background-color: ${props => props.$bg || props.theme.colors.primaryFaint};
  border-left: 6px solid ${props => props.$border || props.theme.colors.primary};
  border-bottom: 1px solid ${props => props.theme.colors.border};
  /* opacity: .7; */
  width: 100%;
  max-width: ${props => `${props.$width}px` || '20rem'};
  border-radius: 2px;
  cursor: pointer;
  /* display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  overflow: hidden; */
  pointer-events: auto;

  &:hover {
    box-shadow: 0 3px 5px 2px rgba(0,0,0,.16);
  }

  @media ${props => props.theme.breaks.down('md')} {
    max-width: ${props => `${props.$width}px` || '15rem'};
  }
`;

const TimelineEventCardInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  overflow: hidden;
  padding: .3rem;
  padding-left: .5rem;
  height: 100%;
  pointer-events: none;

  @media ${props => props.theme.breaks.down('md')} {
    padding: .3rem .2rem;
  }
`;

const TimelineTopBar = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  position: relative;
  gap: .2rem;
`

const TimelineCustName = styled.div`
  font-size: 1.2rem;
  font-weight: 500;

  @media ${props => props.theme.breaks.down('md')} {
    line-height: 1.1rem;
    font-size: 1.1rem;
  }
`;

const TimelineTime = styled.div`
  font-size: 1rem;
  letter-spacing: .5px;
  /* font-style: italic; */

  @media ${props => props.theme.breaks.down('md')} {
    font-size: 1rem;
    letter-spacing: .3px;
  }
`


const TimelineEventTitle = styled.span`
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 500;
  background-color: ${props => props.$clear ? "transparent" : '#fff'};
  border-radius: 2px;
  padding: .1rem .3rem;

  @media ${props => props.theme.breaks.down('md')} {
    font-size: 1.1rem;
    line-height: 1.2rem;
  }
`;

const TimelineCustTime = styled.span`
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 400;
`;

const TimelineEventActions = styled(BasicFlex)`
  position: absolute;
  right: 0;
  top: 0;
  pointer-events: auto;
`;

const TimelineHoursColumn = styled.div`
  min-width: 8.5rem;

  @media ${props => props.theme.breaks.down('md')} {
   min-width: 4.5rem; 
   border-right: 1px solid ${props => props.theme.colors.border};
  }
`;


const TimelineRibbon = styled(BasicRibbon)`
  position: relative;
  justify-content: flex-start;
  height: 6.4rem;
  margin-top: 1.5rem;

  @media ${props => props.theme.breaks.down('md')} {
    height: auto;
    /* padding: .5rem 0; */
    /* overflow-x: scroll; */
    margin-top: 1rem;
  }
`;

const TimelineSeeker = styled.div`
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: ${props => props.theme.colors.primary};
  z-index: 1000;
  left: 0;
  top: ${props => props.pos}px;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background-color: ${props => props.theme.colors.primary};
    z-index: 1000;
  }
`;

/*************  End Timeline Common Styles  ********** */



/*************  Timeline Functions  ********************** */

const processEvents = (events, containerSelector = '.calendar-container') => {
  let eventBlocks = [...events];

  // 1. Sort (Keep your existing sorting logic)
  eventBlocks.sort((a, b) => {
    if (a.start_time === b.start_time) {
      return (a.end_time - a.start_time) - (b.end_time - b.start_time);
    }
    return a.start_time - b.start_time;
  });

  // 2. Assign Columns (Identify vertical lanes)
  eventBlocks.forEach(event => {
    const overlapping = eventBlocks.filter(other => {
      return other.appointment_id !== event.appointment_id &&
        other.start_time < event.end_time &&
        other.end_time > event.start_time &&
        other.column !== undefined; // Only check events already positioned
    });

    let col = 0;
    while (overlapping.some(e => e.column === col)) {
      col++;
    }
    event.column = col;
  });

  const container = document.querySelector(containerSelector);
  const panelWidth = container ? container.getBoundingClientRect().width : 800;

  // 3. Dynamic Width Calculation
  eventBlocks.forEach(event => {
    // Find all events that overlap with THIS event's time range
    const overlappingGroup = eventBlocks.filter(other => {
      return other.start_time < event.end_time && 
             other.end_time > event.start_time;
    });

    // Find the maximum column index present in this specific overlap group
    const localMaxCol = Math.max(...overlappingGroup.map(e => e.column)) + 1;
    
    // Calculate width based on local congestion, not global
    const localColumnWidth = Math.floor(panelWidth / localMaxCol);

    event.left = event.column * localColumnWidth;
    event.width = localColumnWidth;
  });

  return {
    events: eventBlocks,
    panelWidth
  };
};


/*************  End Timeline Functions  ****************** */

const dimensions = { // in rem
  timeline: {
    hour: {
      height: 8,
    }
  }
}

const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

const HebcalTimedEvent = ({title, time, dotColor}) => {
  return (
    <BasicFlex dir="row-reverse" justify="space-between">
      <HebEventTitle>{title}</HebEventTitle>
      <HebTime>
        <TimeDot $dotColor={dotColor} />
        <HebrewTime>{time}</HebrewTime>
      </HebTime>
    </BasicFlex>
  );
}

const ScheduledEventMonthView = ({ event }) => {
  const theme = useTheme();
  let { customer, start_time, end_time } = event;

  const status_colors = {
    "scheduled": theme.palette.secondary.main,
    "in_progress": theme.palette.warning.main,
    "completed": theme.palette.success.main,
    "cancelled": theme.palette.error.main,
  }
  // console.log(event?.block_color, "event?.block_color");
  let bg = event?.block_color || theme.palette.primary.faint;
  let border = status_colors[event?.status];
  return <MonthEvent $bg={bg} $border={border} justify="space-between">
    <Customer>{customer}</Customer>
    <Time>
      <StartTime>{formatTime(start_time, true)}</StartTime>
      <TimeDot />
    </Time>
  </MonthEvent>
}


/*************** Timeline Components *************************** */


const TimelineEventCard = ({event}) => {
  const { start_time, end_time, title, left, customer, number_of_clients, appointment_type, width } = event;
  const { setting } = useCalendarContext() || {};
  let rowHeight = +setting?.data?.view_density || dimensions.timeline.hour.height;
  const height = getEventHeight(start_time, end_time, rowHeight);
  let beginShow = +setting?.data?.display_hours?.start ? +setting?.data?.display_hours?.start : 0;
  const top = getEventTopPos(start_time, rowHeight, beginShow);
  const { isMobile } = useIsMobile();
  const theme = useTheme();
  // console.log(event?.block_color, "event?.block_color");

  const status_colors = {
    "scheduled": theme.palette.secondary.main,
    "in_progress": theme.palette.warning.main,
    "completed": theme.palette.success.main,
    "cancelled": theme.palette.error.main,
  }


  let bg = appointment_type === "customer" ? event?.block_color || lighten(theme.palette.primary.main, .6) : '#fdd5d5';
  let border = appointment_type === "customer" ? status_colors[event?.status] : darken('#fdd5d5', 0.2);
  return (
    <TimelineEventCardStyles $height={height} $top={top} $left={left} $bg={bg} $border={border} $width={width}>
      <AppointmentMenu event={event}>
        {appointment_type === "customer" ? <AppointmentCard event={event} /> : null }
        {appointment_type !== "customer" ? <EventBlockCard event={event} /> : null }
      </AppointmentMenu>

    </TimelineEventCardStyles>
  )
}

const AppointmentCard = ({event}) => {
  const { isMobile } = useIsMobile();
  const { start_time, end_time, title, left, customer, number_of_clients, comment_count, appointment_type, width, invoice_status, booking_source, wig_checked_in } = event;
  let status_color, status;
  const theme = useTheme();
  if (invoice_status) {
    if (invoice_status === "paid") {
      status_color = "success";
      status = "Paid";
    } else if (invoice_status === "partially_paid") {
      status_color = "warning";
      status = "Partially Paid";
    } else {
      status_color = "error";
      status = "Unpaid";
    }
  }
  return (
    <TimelineEventCardInner>
      <TimelineTopBar>
        <BasicFlex onClick={(e) => e.stopPropagation()}>
          <TimelineCustName>
            {/* {displayTruncated(customer, {length: width > 150 ? 30 : 10})}
           */}
            {customer}
            </TimelineCustName>
          {!isMobile && width > 150 ? (
            <TimelineEventActions width="fit-content" justify="flex-end" gap=".3rem">
            {booking_source === "customer_portal" ? <Tooltip title="Online Booking" ><Avatar sx={{width: "1.6rem", height: "1.6rem", bgcolor: "#fff"}}><LanguageRoundedIcon sx={{fontSize: "1.6rem"}} color="info" /></Avatar></Tooltip> : null}
            {wig_checked_in ? <Tooltip title="Wig Checked In"><CheckedWigIcon><WigIconWrapper dimensions="1.4rem" htmlColor={darken(theme.palette.success.main, .1)} opacity={1} /></CheckedWigIcon></Tooltip> : null}
            {invoice_status ? <Tooltip title={status} ><Avatar sx={{width: "1.6rem", height: "1.6rem", bgcolor: "#fff"}}><PaidRoundedIcon sx={{fontSize: "1.6rem"}} color={status_color} /></Avatar></Tooltip> : null}
            <AppointmentComments comment_count={comment_count} notes={event?.service_ticket_notes} event={event} />
            </TimelineEventActions>
          ) : null}
        </BasicFlex>
        {!isMobile && <TimelineTime>
          {formatTime(start_time, true)} - {formatTime(end_time, true)}
        </TimelineTime> }
        {isMobile && <TimelineTime>
          <BasicFlex dir="column" gap=".2rem" px=".2rem" my=".2rem">
            <span>{formatTime(start_time, true)}</span>
            <Divider sx={{width: "3rem", height: "1px", bgcolor: "#555"}} /> 
            <span>{formatTime(end_time, true)}</span>
          </BasicFlex>
        </TimelineTime> }
      </TimelineTopBar>
      <TimelineEventTitle>{title}</TimelineEventTitle> 
    </TimelineEventCardInner>
  )
}

const EventBlockCard = ({event}) => {
  const { isMobile } = useIsMobile();
  const { start_time, end_time, title, left, customer, number_of_clients, appointment_type } = event;
  return (
    <TimelineEventCardInner>
      <TimelineEventTitle $clear>{title}</TimelineEventTitle>
      {!isMobile && <TimelineCustTime>{formatGenericTime(start_time)} - {formatGenericTime(end_time)}</TimelineCustTime> } 
      {isMobile && <TimelineTime>
        <BasicFlex dir="column" gap=".2rem" px=".2rem" my=".2rem">
          <span>{formatTime(start_time, true)}</span>
          <Divider sx={{width: "3rem", height: "1px", bgcolor: "#555"}} /> 
          <span>{formatTime(end_time, true)}</span>
        </BasicFlex>
      </TimelineTime> }
    </TimelineEventCardInner>
  )
}



const PrintTimelineEvents = ({events, track = 1, brackets = "days"}) => {
  // let trackWidth = document.getElementById(`timeline${track}`).getBoundingClientRect().width;
  // let numOfTracks = trackWidth / 300; // based on the available space we calculate the number of tracks, each track is 300px wide
  const { isMobile } = useIsMobile();
  let defaultWidth = isMobile ? 152 : 202;
  let { events: eventBlocks } = processEvents(events, `#${track}`, defaultWidth);

  return (
    eventBlocks.map((event, i) => (
      <TimelineEventCard key={`${event.appointment_id}`} event={event} />
    )))
}


const navigateToDate = (date, navigate) => {
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let year = date.getFullYear();
  navigate(`?view=timeline&date=${month}/${day}/${year}`);
}

const PrintTimelineDay = ({day, dayOfMonth, date, hebDate = {}, auto}) => {
  let hebrewDate = getHebrewDate(date);
  // console.log(hebrewDate);
  const navigate = useNavigate();
  return (
    <TimelineHeaderDay $auto={auto} onClick={() => navigateToDate(date, navigate)}>
      <div className="day">{day}</div>
      <div className="date">{dayOfMonth || ''}</div>
      <div className="hebDate">{hebrewDate}</div>
    </TimelineHeaderDay>
  )
  }

  const PrintTimelineHebEvents = ({ date }) => {
    const { calOptions } = useCalendarContext() || {};

    let events = getEvents(calOptions, date, date);

    let fullDayEvents = [];
    let parsha = getParsha(events);
    if (parsha) {
      fullDayEvents.push({
        title: parsha,
        desc: parsha,
        className: "parashat"
      })
    }
    let candleLighting = getCandleLighting(events, true);
    if (candleLighting) {
      fullDayEvents.push({
        title: candleLighting.renderBrief('he-x-NoNikud'),
        desc: candleLighting.desc,
        className: "candles",
        time: formatTime(candleLighting.eventTime, true),
        icon: <AccessTimeRoundedIcon fontSize='1rem' />
      })
    }
    let havdala = getHavdala(events, true);
    if (havdala) {
      fullDayEvents.push({
        title: havdala.renderBrief('he-x-NoNikud'),
        desc: havdala.desc,
        className: "havdalah",
        time: formatTime(havdala.eventTime, true),
        icon: <AccessTimeRoundedIcon fontSize='1rem' />
      })
    }
   
    let calEvents = getHolidayEvents(date);
    if (calEvents?.length) {
      fullDayEvents.push(...calEvents)
    }
    return (
      fullDayEvents.map(event => {
        let key = Math.random();
        return (
        <FullDateEvent className={event.className} key={key}>
          <span>{event.title}</span> 
          {event.time ? <div className="time"><span>{event.icon}</span>  <span>{event.time}</span> </div> : null}
        </FullDateEvent>
      )
    })
    )
  }

/*************** End Timeline Components *********************** */

const defaultActiveHours = [
  {hour: 0, active: false},
  {hour: 1, active: false},
  {hour: 2, active: false},
  {hour: 3, active: false},
  {hour: 4, active: false},
  {hour: 5, active: false},
  {hour: 6, active: false},
  {hour: 7, active: false},
  {hour: 8, active: false},
  {hour: 9, active: true},
  {hour: 10, active: true},
  {hour: 11, active: true},
  {hour: 12, active: true},
  {hour: 13, active: true},
  {hour: 14, active: true},
  {hour: 15, active: true},
  {hour: 16, active: true},
  {hour: 17, active: true},
  {hour: 18, active: false},
  {hour: 19, active: false},
  {hour: 20, active: false},
  {hour: 21, active: false},
  {hour: 22, active: false},
  {hour: 23, active: false},
]

let mockEvents = [
  {
    id: 1,
    stylistId: "1",
    start: "2024-12-25T14:45:00.000+00:00",
    end: "2024-12-25T17:55:00.000+00:00",
    title: "Wash & Set",
    customer: {
      name: "Rivka Goldwasser",
      phone: "718-555-1234",
      email: ""
    }
  },
  {
    id: 2,
    stylistId: "1",
    start: "2024-12-25T14:55:00.000+00:00",
    end: "2024-12-25T16:05:00.000+00:00",
    title: "Hair Cut",
    customer: {
      name: "Leah Schwartz",
      phone: "718-555-1234",
      email: ""
    }
  },
  {
    id: 3,
    stylistId: "2",
    start: "2024-12-25T15:07:00.000+00:00",
    end: "2024-12-25T16:05:00.000+00:00",
    title: "Coloring",
    customer: {
      name: "Chaya Greenbaum",
      phone: "718-555-1234",
      email: ""
    }
  },
  {
    id: 4,
    stylistId: "2",
    start: "2024-12-16T08:10:00.000+00:00",
    end: "2024-12-16T09:10:00.000+00:00",
    title: "Hair Cut",
    customer: {
      name: "Chana Cohen",
      phone: "718-555-1234",
      email: ""
    },
    theme:{bg: "lightcyan", border: 'cyan'}
  },
  {
    id: 5,
    stylistId: "2",
    start: "2024-12-13T09:15:00.000+00:00",
    end: "2024-12-13T10:15:00.000+00:00",
    title: "Wash & Set",
    customer: {
      name: "Rivka Goldwasser",
      phone: "718-555-1234",
      email: ""
    }
  }
]

export {
  HebcalTimedEvent,
  ScheduledEventMonthView,
  BasicRibbon,
  dimensions,
  dayNames,
  FullDateEvent,
  mockEvents,


  TimelineTableHead,
  TimelineTableDateEventBar,
  TimelineTableWeekBar,
  TimelineSpacer,
  TimelineFullDateEventsContainer,
  TimelineLegalHolidays,
  TimelineJewishHolidays,
  TimelineHeaderDay,
  TimelineIconContainer,
  TimelineTableBodyContainer,
  TimelineTrackHeader,
  TimelineTrackHeaderScroll,
  TimelineTrackTitle,
  TimelineTableBody,
  TableTimelineDisplay,
  TimelineEventBoard,
  TimelineEventCardStyles,
  TimelineCustName,
  TimelineEventTitle,
  TimelineCustTime,
  TimelineHoursColumn,
  // TimelineHour,
  TimelineRibbon,
  TimelineSeeker,
  TimelineTrack,
  WeekDayTrack,


  PrintTimelineEvents,
  PrintTimelineDay,
  // PrintTimelineHours,
  PrintTimelineHebEvents
}
